<td class="text-left td-class list-row" [ngClass]="{'cancelled': isItemCancelled()}">
    <div class="d-flex flex-row ">
        <div class="align-items-center pr-3 justify-content-start">
            <span class="circle">
                <app-group-classes-category-icon [category]="item.category.code" [status]="item.status.code">
                </app-group-classes-category-icon>
            </span>
        </div>
        <div class="align-items-center text-left">
            <div>{{item.category.name}}</div>
            <div><strong>{{item.name}}</strong></div>
        </div>
    </div>
</td>
<td class="text-left td-date  list-row" [ngClass]="{'cancelled': isItemCancelled()}">
    <div> {{item.date | bcDate: 'dd MMM D'}}</div>
    <div> {{item.timeFromInMinutes | timeDisplay}} - {{item.timeToInMinutes | timeDisplay}}</div>
</td>
<td class="text-left td-location list-row" [ngClass]="{'cancelled': isItemCancelled()}">{{item.club.shortName}}</td>
<td class="text-left td-instructor list-row" [ngClass]="{'cancelled': isItemCancelled()}">
    <div *ngIf="item.substituteInstructor">
        <div>
            {{item.substituteInstructor.name}}
        </div>
        <div class="substitute">Substituted</div>
    </div>
    <span *ngIf="item.instructor && !item.substituteInstructor">
        {{item.instructor.name}}
    </span>
</td>
<td class="list-row" [ngClass]="{'cancelled': isItemCancelled()}">{{item.status.name}}</td>
